export default "Aides Professionnels — CEE BAT, Coup de pouce CVC, Bpifrance, suramortissement | Solution Éco France";
